import { EXPERIMENT_DEFAULT_VALUES } from '../config';

export const getExperiment = (experimentName: string) => {
  if (document.flags?.[experimentName] === undefined) {
    return EXPERIMENT_DEFAULT_VALUES[experimentName];
  }

  return document.flags[experimentName];
};
